import * as React from "react";

/** Which shortcut surface is open. Search is Cmd+K and Zot is Cmd+J. */
export type CommandSurface = "search" | "zot" | null;

/**
 * Listens for the two shell shortcuts. The dialogs are placeholders: search and Zot themselves are
 * later tasks, but the keys must already open something a person can dismiss.
 */
export function useCommandSurface(): [CommandSurface, (surface: CommandSurface) => void] {
  const [surface, setSurface] = React.useState<CommandSurface>(null);

  React.useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) return;
      if (event.key.toLowerCase() === "k") {
        event.preventDefault();
        setSurface("search");
      } else if (event.key.toLowerCase() === "j") {
        event.preventDefault();
        setSurface("zot");
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return [surface, setSurface];
}
